import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { Query } from 'react-apollo';
import { HANDLE } from '@graphql/queries/handle';
import { Handle, HandleVariables, CurrentUser } from '@graphql/types';
import { Spinner } from '@components/Spinner';
import { ErrorPage } from '@components/Error';

// import { LoadableVendorRouter } from '../routes/vendor';
import { LoadableEventRouter } from '../routes/event';
import { JoyHeader } from '@components/JoyHeader';

interface Props {
  handle: string;
  customDomain?: boolean;
  currentUser?: CurrentUser;
}

export class VendorOrEventHandler extends React.Component<Props, {}> {
  render() {
    return (
      <Query<Handle, HandleVariables>
        notifyOnNetworkStatusChange={true}
        query={HANDLE}
        fetchPolicy={'network-only'}
        variables={{ handle: this.props.handle }}
      >
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ margin: '40px' }}>
                <JoyHeader />
                <Spinner id={'HANDLE'} style={{ top: '20%', height: '50%' }} />
              </div>
            );
          }
          if (error) {
            // this is here for the case when preview loads but the iframe errors out
            // we want the error component to render in the preview route not inside the iframe
            try {
              if (window.top.onIframeError) {
                window.top.onIframeError(error);
                return;
              }
              return;
            } catch (e) {
              // do nothing
            }
            return (
              <ErrorPage
                error={error}
                page="eventRouter"
                pagePrefix="marketing"
                category="Bliss"
                attemptedAction="Event Query"
              />
            );
          }
          if (data) {
            if (data.handle) {
              return (
                <LoadableEventRouter
                  event={data.handle}
                  customDomain={this.props.customDomain || false}
                  currentUser={this.props.currentUser}
                />
              );
            } else {
              return <Redirect to={'/404'} />;
            }
          }
          return null;
        }}
      </Query>
    );
  }
}
